import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "question__head" }
const _hoisted_2 = { class: "question__title" }
const _hoisted_3 = { class: "question__body" }

import "./Question.scss";
import Spoiler from "@/components/Spoiler/Spoiler.vue";
import Icon from "@/components/Icon/Icon.vue";

interface Props{
	title : string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Question',
  props: {
    title: {}
  },
  setup(__props: any) {

let props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Spoiler, { class: "question" }, {
    button: _withCtx(({opened}) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(props).title), 1),
        _createElementVNode("i", {
          class: _normalizeClass(["question__icon", {'question__icon--opened' : opened}])
        }, [
          _createVNode(Icon, { name: "down" })
        ], 2)
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }))
}
}

})